export default "__VITE_ASSET__8a70a41e__"